import { Injectable } from '@angular/core'
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad, Route } from '@angular/router'
import { SessionService } from './services/session.service'

@Injectable()
export class AuthPrivateGuard implements CanActivate, CanLoad {
	constructor(private sessionService: SessionService, private router: Router) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.handle()
	}

	canLoad(route: Route): boolean {
		return this.handle()
	}

	handle() {
		if (this.sessionService.is_logged_in) return true
		this.router.navigate(['/login'])
		return false
	}
}

@Injectable()
export class AuthProviderPrivateGuard implements CanActivate, CanLoad {
	constructor(private sessionService: SessionService, private router: Router) {

	}
	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.handle()
	}

	canLoad(route: Route): boolean {
		return this.handle()
	}

	handle() {
		if (this.sessionService.is_provider_logged_in) return true
		this.router.navigate(['/login'])
		return false
	}
}

@Injectable()
export class AuthPublicGuard implements CanActivate, CanLoad {
	constructor(private sessionService: SessionService, private router: Router) {

	}
	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.handle()
	}

	canLoad(route: Route): boolean {
		return this.handle()
	}
	handle() {
		if (!this.sessionService.is_logged_in && !this.sessionService.is_provider_logged_in) {
			return true
		} else if (this.sessionService.is_logged_in) {
			this.router.navigate(['/'])
		} else if (this.sessionService.is_provider_logged_in) {
			this.router.navigate(['/p'])
		}
		return false
	}
}

export const appRoutingProviders: any[] = [AuthPrivateGuard, AuthPublicGuard, AuthProviderPrivateGuard]



// WEBPACK FOOTER //
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/auth.guard.ts